module.exports = __webpack_public_path__ + "static/media/settings-black.fa8d1c91.svg";